import { useCallback } from 'react'
import { GooglePlaceDetail } from 'react-native-google-places-autocomplete'

import { blankAddressSearch } from '../constants'

interface AddressType {
  state?: string
  country?: string
}

/**
 * Given the google places data, create the location object to use in the store
 */
export const useLocationGeoData = ({ isGooglePlacesAPIEnabled = false }: { isGooglePlacesAPIEnabled: boolean }) => {
  return useCallback(
    ({ details }: { details: GooglePlaceDetail }) => {
      let newAddressObj = Object.assign({}, blankAddressSearch, {
        userInput: '',
        lat: isGooglePlacesAPIEnabled ? details.location.latitude : details.geometry.location.lat,
        lon: isGooglePlacesAPIEnabled ? details.location.longitude : details.geometry.location.lng,
        formattedAddress: isGooglePlacesAPIEnabled ? details.formattedAddress : details.formatted_address,
      })

      const addressComponents = isGooglePlacesAPIEnabled ? details.addressComponents : details.address_components
      const addressTypes: AddressType = addressComponents.reduce((prev, curr) => {
        if (curr.types.includes('administrative_area_level_1')) {
          return { state: isGooglePlacesAPIEnabled ? curr.shortText : curr.short_name, ...prev }
        } else if (curr.types.includes('country')) {
          return { country: isGooglePlacesAPIEnabled ? curr.longText : curr.long_name, ...prev }
        }
        return prev
      }, {})
      // Temporary workaround to address Google handling Puerto Rico or Guam as a separate country
      // PSS / Arbiter assumes Puerto Rico or Guam as a region of the US but we don't have the syntax to indicate it
      // Thus we forcibly modify the generated location payload such that Puerto Rico or Guam is represented as both the province and the country.
      if (addressTypes.country === 'Puerto Rico') {
        addressTypes.state = 'PR'
      }
      if (addressTypes.country === 'Guam') {
        addressTypes.state = 'GU'
      }
      newAddressObj = Object.assign({}, newAddressObj, addressTypes)
      return newAddressObj
    },
    [isGooglePlacesAPIEnabled],
  )
}
